/**
 * ICOM “qualifying as a museum” institution types (tick one).
 * Stored as a single-element JSON array on Institution.InstitutionType.
 */
export const ICOM_INSTITUTION_TYPE_KEYS = [
  'monumentOrSite',
  'liveSpecimens',
  'scienceCentreOrPlanetarium',
  'nonProfitGalleryOrInstitute',
  'natureReserve',
  'museumOrganisationOrAgency',
  'researchOrganisation',
  'culturalCentreOrHeritage',
] as const;

export type IcomInstitutionTypeKey = (typeof ICOM_INSTITUTION_TYPE_KEYS)[number];

export function isIcomInstitutionTypeKey(value: string): value is IcomInstitutionTypeKey {
  return (ICOM_INSTITUTION_TYPE_KEYS as readonly string[]).includes(value);
}

/** Resolve a stored type key (or legacy free text) to a display label. */
export function formatInstitutionTypeLabel(
  value: string,
  t: (key: string, options?: Record<string, unknown>) => string,
): string {
  if (isIcomInstitutionTypeKey(value)) {
    return t(`institution.icomType.options.${value}`);
  }
  return value;
}
